import type { ReactNode } from 'react';
import { usePermission } from '../../hooks/usePermission';
import type { Permission } from '../../lib/permissions';

interface PermissionGateProps {
  permission: Permission;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Renders children only when the authenticated user has the required permission.
 * Renders fallback (default: nothing) otherwise.
 * The backend always enforces permissions — this is a UX aid, not a security boundary.
 */
export function PermissionGate({
  permission,
  children,
  fallback = null,
}: PermissionGateProps): ReactNode {
  const allowed = usePermission(permission);
  return allowed ? children : fallback;
}
